import { Action, SelectedVehicleActions } from './selected-vehicle-actions';
import { tassign } from 'tassign';
import { SelectedVehicleState, initialSelectedVehicleState } from './selected-vehicle-state.model';

/**
* @function SelectedVehicleReducer Will excecute the according triggered in the dispatcher
* @param state Store model
* @param action The action that will affect the store
* @return {tassing<SelectedVehicleState>} Value with the store
**/
export const SelectedVehicleReducer = function (state: SelectedVehicleState = initialSelectedVehicleState, action: Action): SelectedVehicleState {
  switch (action.type) {
    case SelectedVehicleActions.SET_SELECTED_VEHICLE:
      return tassign(state, { vehicle: action.payload.vehicle });
    case SelectedVehicleActions.RESET_SELECTED_VEHICLESTORE:
      return initialSelectedVehicleState;
    default:
      return state;
  }
};


